import { useEffect, useState } from 'react';
import { DELETE } from 'shared/components/vxl/NumberPad/NumberPadButton';

export const useHandleKeypadButtonPress = (initialPercentage: string) => {
  const [updatedSYPPercentage, setUpdatedSYPPercentage] =
    useState(initialPercentage);
  const [isUpdatingFirstTime, setIsUpdatingFirstTime] = useState(true);

  useEffect(() => {
    setUpdatedSYPPercentage(initialPercentage);
  }, [initialPercentage]);

  const handleKeypadButtonPress = (value: string) => {
    setUpdatedSYPPercentage((prev) => {
      const baseValue = prev.endsWith('%') ? prev.slice(0, -1) : prev;

      if (value === DELETE) {
        setIsUpdatingFirstTime(false);

        if (baseValue === '0') {
          return '0%'; // If value is 0, don't change anything
        }
        const newBaseValue = baseValue.slice(0, -1) || '0'; // Remove the last digit
        return newBaseValue + '%';
      }

      // Replace old value with the new value for the very first time
      if (isUpdatingFirstTime) {
        setIsUpdatingFirstTime(false);
        return value + '%';
      }

      if (baseValue === '0' || baseValue === '00') {
        return value + '%'; // Replace 0 or 00 with the new digit
      }

      if (baseValue.length >= 3) {
        return value + '%'; // Prevent adding more than 3 digits
      }

      return baseValue + value + '%'; // Append the new digit
    });
  };

  return {
    updatedSYPPercentage,
    handleKeypadButtonPress,
  };
};
